export const PLACE_CARD_AFTER = 4;
export const PRODUCT_TO_ARTICLES_RATIO = [
  {
    PRODUCTS: 6,
    ARTICLES: 1
  },
  {
    PRODUCTS: 10,
    ARTICLES: 2
  },
  {
    PRODUCTS: 14,
    ARTICLES: 3
  }
]
